import styled, { keyframes } from 'styled-components';

const TypingKeyframes = keyframes`
  50% { opacity: .2 }
`;

const TypingContainer = styled.svg`
  height: 44px;
  width: 72px;
  background-color: ${({ theme }) => theme.background.weak};
  border-radius: ${({ theme }) => theme.borderRadius.round};

  & .dot {
    animation: 1.2s ${TypingKeyframes} infinite;
    fill: #228be6;
  }
  & .dot:nth-child(2) {
    animation-delay: 250ms;
  }
  & .dot:nth-child(3) {
    animation-delay: 500ms;
  }
`;

const TypingAnimation = () => {
  return (
    <TypingContainer>
      <circle className='dot' cx='22' cy='22' r='4' />
      <circle className='dot' cx='36' cy='22' r='4' />
      <circle className='dot' cx='50' cy='22' r='4' />
    </TypingContainer>
  );
};

export default TypingAnimation;
